import axiosClient from './axiosClient';

const learningPathApi = {
  /**
   * create learning path
   * @param {LearningPathProps} data
   * @returns {Promise<{success: boolean}>}
   */
  create: (data) => {
    const url = `/learning-path`;
    return axiosClient.post(url, data);
  },
  /**
   * get particular learning path by id
   * @param {string} id
   * @returns {Promise<LearningPathProps>}
   */

  detele: (id) => {
    const url = `/learning-path/delete-learning-path/${id}`;
    return axiosClient.delete(url);
  },
  /**
   * get the all learning path
   *
   * @param {{page?: number, rowPerPage?: number, textSearch?: string}} params
   * @returns {Promise<{data: LearningPathProps[], currentPage: number, totalPage: number | null, totalItems: number }>}
   */
  get: (params) => {
    const url = `/learning-path`;
    return axiosClient.get(url, { params });
  },
  /**
   *
   * @param {*} data
   * @param {*} param
   * @returns
   */
  LearningPathByPost: (data, { params, headers }) => {
    const url = `/learning-path/get-learning-path`;
    return axiosClient.post(url, data, { params, headers });
  },
  /**
   * get user enrolled learning path
   * @param {{page?: number, rowPerPage?: number, textSearch?: string}} params
   * @returns {Promise<{data: UserEnrollLearningPathProps[], currentPage: number, totalPage: number | null, totalItems: number }>}
   */
  getUser: (params) => {
    const url = `/learning-path/get-user-learning-path`;
    return axiosClient.get(url, { params });
  },

  /**
   * get particular learning path by id
   * @param {string} id
   * @returns {Promise<LearningPathProps>}
   */
  getId: (id) => {
    const url = `/learning-path/${id}`;
    return axiosClient.get(url);
  },

  /**
   * update learning path
   * @param {string} id
   * @returns {Promise<{success: Boolean}>}
   */
  update: (id, data) => {
    const url = `/learning-path/${id}`;
    return axiosClient.put(url, data);
  },

  /**
   * user learning path by id
   * @param {string} id
   * @returns {Promise<UserEnrollLearningPathProps[]>}
   */
  getEnrollUserPath: (id) => {
    const url = `/learning-path/get-user-learning-path/${id}`;
    return axiosClient.get(url);
  },

  /**
   * enroll the user to learning path
   * @param {*} data
   * @returns
   */
  userEnroll: (data) => {
    const url = `/learning-path/learning-paths-enrollment`;
    return axiosClient.post(url, data);
  },

  /**
   * enroll the user to learning path
   * @param {*} data
   * @returns
   */
  userEnrollment: (data) => {
    const url = `/learning-path/learning-path-enrollment`;
    return axiosClient.post(url, data);
  },

  /**
   * @param {{page?: number, rowPerPage?: number, textSearch?: string}} params
   * @returns {Promise<{data: LearningPathReports[]} & import('components/React-table/commonCellAction').INIT_DATA>}
   */
  getReportLearningPath: (params) => {
    const url = `/learning-path/reports/learning-path-reports`;
    return axiosClient.get(url, { params });
  },

  getReportByPost: (data, { params, headers }) => {
    const url = '/learning-path/reports/learning-path-reports';
    return axiosClient.post(url, data, { params, headers });
  },

  getReportLearningpathReport: (data, params) => {
    const url = `/learning-path/reports/learning-path-reports`;
    return axiosClient.post(url, data, { params });
  },

  /**
   * @param {{page?: number, rowPerPage?: number, textSearch?: string}} params
   * @returns {Promise<{data: object[]} & import('components/React-table/commonCellAction').INIT_DATA>}
   */
  getUserReportLearningPath: (params) => {
    const url = `/learning-path/reports/learning-path-user-report`;
    return axiosClient.get(url, { params });
  },

  getUserReportByPost: (data, { params, headers }) => {
    const url = '/learning-path/reports/learning-path-user-report';
    return axiosClient.post(url, data, { params, headers });
  },

  getLearningPathUserReport: (data, params) => {
    const url = `/learning-path/reports/learning-path-user-report`;
    return axiosClient.post(url, data, { params });
  },

  userUnEnroll: (id) => {
    const url = `/learning-path/learning-path-enrollment/${id}`;
    return axiosClient.delete(url);
  },

  /**
   * @param {{page?: number, rowPerPage?: number, textSearch?: string, courseCentre?: string, learningPathId?: string}} params
   * @returns {Promise<{data: any[], learningPath: LearningPathProps} & import('components/React-table/commonCellAction').INIT_DATA>}
   */
  learningPathListUser: (params) => {
    const url = `/learning-path/get-Learning-path-users`;
    return axiosClient.get(url, { params });
  },
  advanceFilterUsers: (body, options) => {
    const url = `/learning-path/get-Learning-path-users`;
    return axiosClient.post(url, body, options);
  },

  /**
   * @param {{pathId: string}} params
   * @returns {Promise<{data: import('./userApi').UserProps[], totalItems: number}>}
   */
  userFilterByPathId: (pathId) => {
    const url = `/learning-path/filtered-users/${pathId}`;
    return axiosClient.get(url);
  },
  /**
   *
   * @param {{learning_id: string, courseCentre: string[]}} data
   * @returns {Promise<{data: LearningPathProps[], currentPage: number, totalPage: number | null, totalItems: number }>}
   */
  cloneLearningPath: (data) => {
    const url = `/learning-path/cloneLearningPath`;
    return axiosClient.post(url, data);
  },
};

export default learningPathApi;

/**
 * @typedef LearningPathProps
 * @property {string} title
 * @property {CourseCentre} courseCentre
 * @property {{intake: Course[], totalHour: number, totalPoints: number, _id: string}[]} learningPathStages
 * @property {string} status
 * @property {import('./userApi').UserProps} creator
 * @property {string} createdAt
 * @property {number} totalStageDays
 * @property {number} totalStagePoints
 * @property {number} learningPathProgress
 * @property {string} _id
 */

/**
 * @typedef UserEnrollLearningPathProps
 * @property {string} status
 * @property {CourseCentre} courseCentre
 * @property {import('./userApi').UserProps} user
 * @property {string} createdAt - date format
 * @property {string} updatedAt - date format
 * @property {string} enrolledDate - date format
 * @property {enrolledStageProps[]} enrolledStage
 * @property {LearningPathProps & {enrolledUsers: string}} learningPath
 * @property {string} _id
 */

/**
 * @typedef enrolledStageProps
 * @property {CourseInfoProps[]} intake
 * @property {string} stage - object id
 * @property {string} stageEnrolledDate - date format
 * @property {number} stageTotalHour
 * @property {string} status
 * @property {string} _id
 */

/**
 * @typedef LearningPathReports
 * @property {CourseCentre[]} courseCentre
 * @property {CourseCentre} centreData
 * @property {import('./userApi').UserProps} creator
 * @property {string} status
 * @property {string} title
 * @property {number} totalCompletedCount
 * @property {number} totalEnrolledCount
 * @property {number} totalNotYetStartedCount
 * @property {number} totalInprogressCount
 * @property {number} totalStageDays
 * @property {number} totalStagePoints
 * @property {string} _id
 */

/**
 * @typedef LearningPathUserReports
 * @property {string} courseCentre
 * @property {CourseCentre[]} centreData
 * @property {import('./userApi').UserProps} user
 * @property {import('./userApi').UserProps} creator
 * @property {string} status
 * @property {enrolledStageProps} enrolledStage
 * @property {string} _id
 */
